<template>
  <div>
    <GeneralPrescription class="isDesktop" />
    <!-- <MobileGeneral class="isMobile" /> -->
  </div>
</template>

<script>
import GeneralPrescription from "../../components/Prescription/GeneralPrescription.vue";
// import MobileGeneral from "../../components/Prescription/MobileGeneral.vue";
export default {
  components: {
    GeneralPrescription,
    // MobileGeneral,
  },
};
</script>
<style>
.isMobile {
  display: none !important;
}
@media screen and (max-width: 700px) {
  .isDesktop {
    display: none !important;
  }
  .isMobile {
    display: flex !important;
  }
}
</style>